import { useState, useEffect, useRef } from 'react';
import {
    DropdownArrow
} from "../AllSvg";

function SearchableDropdown({ projectList, SetFilter }) {
    const [searchTerm, setSearchTerm] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const sorted = projectList?.sort((a, b) =>
            a.project_short_name?.localeCompare(b.project_short_name, 'en', { ignorePunctuation: true })
        );
        if (searchTerm === '') {
            setFilteredProjects(sorted);
        } else {
            setFilteredProjects(
                sorted?.filter((p) =>
                    `${p.prebid_prcode}-${p.project_short_name}`.toLowerCase().includes(searchTerm.toLowerCase())
                )
            );
        }
    }, [searchTerm, projectList]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSelect = (value) => {
        setSearchTerm(value.label);
        SetFilter(value.value);
        setShowDropdown(false);
    };

    const toggleDropdown = () => {
        setShowDropdown((prev) => !prev);
    };

    return (
        <div className="field-cont" ref={dropdownRef}>
            <div
                className="table-searchh-new dropdown-container field-cont-div"
                style={{ position: 'relative', width: '30vw' }}
            >
                <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onFocus={() => setShowDropdown(true)}
                    className="dropdown-timesheet font-size-subheading"
                    placeholder="Select Project"
                    style={{ width: '100%', padding: '8px 35px 8px 8px' }} // right padding for icon space
                />
                {/* Dropdown Icon */}
                <div
                    onClick={toggleDropdown}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        pointerEvents: 'auto',
                        zIndex: 30,
                    }}
                >
                    <DropdownArrow />
                </div>

                {/* Dropdown List */}
                {showDropdown && (
                    <div
                        className="dropdown-list"
                        style={{
                            top: '100%',
                            position: 'absolute',
                            width: '100%',
                            background: 'white',
                            border: '1px solid #ccc',
                            zIndex: 20,
                            maxHeight: '500px',
                            overflowY: 'auto',
                            borderRadius: '0 0px 10px 10px',
                        }}
                    >
                        {filteredProjects?.length > 0 ? (
                            filteredProjects.map((proj, index) => {
                                const label = `${proj.prebid_prcode}-${proj.project_short_name}`;
                                return (
                                    <div
                                        key={index}
                                        onClick={() => handleSelect({ label, value: proj.prebid_prcode })}
                                        style={{
                                            padding: '8px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                        }}
                                        onMouseDown={(e) => e.preventDefault()}
                                    >
                                        {label}
                                    </div>
                                );
                            })
                        ) : (
                            <div style={{ padding: '8px' }}>No results found</div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default SearchableDropdown;
